import { saveAs } from 'file-saver'
export const downloadImage = (url,name) => {
    saveAs(url, `${name}.jpg`) // Put your image url here.
}